var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15.767,
    viewBox: "0 0 21 15.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M0,14.34V1.291A1.342,1.342,0,0,1,.408.34,1.292,1.292,0,0,1,1.291,0H8.835a.772.772,0,0,1,.544.2A.914.914,0,0,1,9.786.68l.68,1.9h9.175a1.342,1.342,0,0,1,.951.408A1.234,1.234,0,0,1,21,3.942V14.408a1.342,1.342,0,0,1-.408.951,1.234,1.234,0,0,1-.951.408H1.291a1.342,1.342,0,0,1-.951-.408A1.831,1.831,0,0,1,0,14.34Z",
    transform: "translate(0)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.71ea69a08e3842cbbeca7d75ec6567da.svg";
export { ForwardRef as ReactComponent };